import { AuthState } from '@/types/auth'

export const AUTH_STORAGE_KEY = 'auth'
export const USER_SESSION_SNAPSHOT_KEY = 'auth:user-session'
export const TENANT_STORAGE_KEYS = ['currentTenant', 'selectedTenant'] as const

const AUTH_STORAGE_KEYS = [AUTH_STORAGE_KEY, USER_SESSION_SNAPSHOT_KEY, ...TENANT_STORAGE_KEYS]

type StoredAuthSnapshot = Pick<AuthState, 'token'>

export function readStoredAuth(): StoredAuthSnapshot | null {
  const rawValue = localStorage.getItem(AUTH_STORAGE_KEY)
  if (!rawValue) return null

  try {
    return JSON.parse(rawValue) as StoredAuthSnapshot
  } catch (error) {
    console.error('Erro ao ler sessão autenticada:', error)
    localStorage.removeItem(AUTH_STORAGE_KEY)
    return null
  }
}

export function clearAuthStorage() {
  AUTH_STORAGE_KEYS.forEach(key => {
    localStorage.removeItem(key)
  })
}
